import { createRoute } from '@tanstack/react-router';
import { PnlPage } from '@/features/finance/Pnl';
import { Route as shellRoute } from '../_shell';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/finance/pnl',
  component: PnlPage,
});
